import React from "react";
import "./component.scss"
import $ from "jquery"
import { Link } from "react-router-dom";
export default function Footer(){

    return (
        <footer className="Footer">
<div className="lists">
        <div className="list">
            <button className="b" onClick={()=>{$(".listitems1 ").toggle()}}><h1 className="footerh1">Links</h1></button>
            <div className="listitems listitems1">
                <p> <a className="aa" href='https://www.linkedin.com/in/abiboulaye-diagne-84884225b/'>Linkedin</a></p>
                <p> <a className="aa" href='https://github.com/Hackerbibou'>Github</a></p>
                <p> <a className="aa" href='https://git.generalassemb.ly/hackerbibou?tab=repositories'>Enterprise</a></p>
                <p> <a className="aa" href='https://abiboulayediagne.wordpress.com/'>Blog</a></p>
        </div>
        </div>
        
        <div className="list">
        <button className="b" onClick={()=>{$(".listitems2 ").toggle()}}><h1 className="footerh1">Deploys</h1></button>
            <div className="listitems listitems2">
                <div>
                <p> <a className="aa" href='https://shopflix.onrender.com/'>Netflix Clone</a></p>
                <p> <a className="aa" href='https://codify.fly.dev/'>Social Media App</a></p>
                <p> <a className="aa" href='https://bookreadingapp.onrender.com/books/'>Book Reading App</a></p>
                <p> <a className="aa" href='https://helpful-biscochitos-34ff64.netlify.app/'>Wordle Game</a></p>
                <p> <a className="aa" href='https://hackerbibou.github.io/Javascript-browser-game/'>Card Guessing Game</a></p>
                </div>
            </div>
        </div>
      
        <div className="list">
        <button className="b" onClick={()=>{$(".listitems3 ").toggle()}}><h1 className="footerh1">Languages</h1></button>
            <div className="listitems listitems3">
               
                <p>English</p>
                <p>French</p>
                <p>Wolof</p>
            </div>
        </div>
      
        <div className="list">
        <button className="b" onClick={()=>{$(".listitems4 ").toggle()}}><h1 className="footerh1">About Me</h1></button>
            <div className="listitems listitems4">
                
               <Link to='/bio'><p>Bio</p></Link> 
                <p>Projects</p>
                <p>Passion</p>
            </div>
        </div>
      
        </div>
       
        <p style={{margin:"60px", fontSize:"12px"}}>Copyright Abiboulaye Diagne © {new Date().getFullYear()} My UI Page</p>
        
      </footer>
      )

}